import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import SettingsIcon from '@material-ui/icons/Settings';
import SnoozeIcon from '@material-ui/icons/Snooze';
import MuteAlarmIcon from '@material-ui/icons/VolumeOff';
import AlarmsOnIcon from '@material-ui/icons/VolumeMute';
import soundFile from '../sounds/chime.mp3';
import { styles } from '../styles/dashboard-styles';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alarmActivated: false,
      alarmActivatedCount: 0
    }
  }

  handleAlarmActivated = () => {
    const alarmActivated = !this.state.alarmActivated;
    alarmActivated ? this.playAlarm() : this.pauseAlarm();
    this.setState({
      alarmActivated,
      alarmActivatedCount: this.state.alarmActivatedCount + 1
    })
  }
  handleSnoozeOn = () => {
    this.handleAlarmActivated()
    setTimeout(function() {
      this.handleAlarmActivated();
    }.bind(this), 300000);
  }


  playAlarm = () => {
    document.getElementById("alarm").play();
  }

  pauseAlarm = () => {
    document.getElementById("alarm").pause();
  }
  componentWillMount() {
    this.setState({
      alarmActivated: this.props.alarmSoundOn
    })
  }
  componentDidUpdate(prevProps) {
    if(prevProps.alarmSoundOn !== this.props.alarmSoundOn) {
        this.setState({
          alarmActivated: this.props.alarmSoundOn
        })      
      if(!this.props.alarmSoundOn) {
        this.pauseAlarm();
      }
    }
  }

  render() {
    if(this.state.alarmActivated && this.props.alarmSoundOn && document.getElementById("alarm") !== null) {
      this.playAlarm();
      }
    const { classes } = this.props;
    const alarmSoundIcon = () => {
      return this.state.alarmActivated ? <MuteAlarmIcon /> : <AlarmsOnIcon />;
      }
    return (
  
      <AppBar
        position="absolute"
        className={classNames(classes.appBar, this.props.open && classes.appBarShift)}
      >
        <Toolbar disableGutters={!this.props.open} >
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={this.props.handleDrawerOpen}
            className={classNames(
              classes.menuButton,
              this.props.open && classes.menuButtonHidden,
            )}
          >
            <SettingsIcon />
          </IconButton>
          <div className={classes.toolbar}>
            {this.props.title}
            <div>
              <IconButton
                classes={{root: classes.menuButton}}
                color="inherit"
                aria-label="Alarm Sound"
                onClick={this.handleSnoozeOn}
                disabled={!this.state.alarmActivated}
              >
                <audio id="alarm" loop>
                <source src={soundFile} type="audio/mpeg" />
                </audio>
                <SnoozeIcon />
              </IconButton>
              <Button
                classes={{root: classes.logout}}
                onClick={this.props.handleClearAllAlerts}
                disabled={this.props.clearAllAlertsDisabled}>
                Clear All Alerts
              </Button>
              <Button
                classes={{root: classes.logout}}
                onClick={this.props.handleLogout}>
                Log out
              </Button>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    )
  }
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NavBar);



// WEBPACK FOOTER //
// ./src/components/NavBar.js